import script from "./HighScores.vue?vue&type=script&setup=true&lang=js"
export * from "./HighScores.vue?vue&type=script&setup=true&lang=js"

import "./HighScores.vue?vue&type=style&index=0&id=6016c8b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6016c8b2"]])

export default __exports__